import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ReportTypeCode} from '../model/reportTypeCode';
import {ReportService} from './report.service';
import {DebuggingDTO} from '../model/debuggingDTO';

@Injectable({
  providedIn: 'root'
})
export class DebuggingService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'debugging';

  constructor(private http: HttpClient) {
  }

  get(clientId: number, reportType: ReportTypeCode, year: number) {
    return this.http.get<DebuggingDTO>(`${this.path}/${clientId}/${reportType}?${ReportService.yearAppendix(year)}`);
  }
}
